import { DisplayObject, Container } from 'pixi.js'

declare module 'pixi.js' {
  interface Container {
    destroyChild: (child: DisplayObject) => void
    destroyChildren: () => void
  }
}

Container.prototype.destroyChild = function (child: DisplayObject) {
  if (this.children.includes(child)) {
    this.removeChild(child)
    if (typeof child.destroy === 'function') {
      child.destroy({ children: true })
    }
  }
}

Container.prototype.destroyChildren = function () {
  while (this.children.length > 0) {
    const child = this.removeChildAt(0)
    if (child && typeof child.destroy === 'function') {
      child.destroy({ children: true })
    }
  }
}
